module.exports = __webpack_public_path__ + "static/media/most-transactions-denied-season.cb16706b.png";